import { useMutation } from '@tanstack/react-query';

import { getGoogleApiKey } from '@/utils';

const usePlaceDetails = (
  onSuccess: (_place: google.maps.places.Place) => void,
) => {
  const googleMapsApiKey = getGoogleApiKey(
    process.env.NEXT_PUBLIC_GOOGLE_MAP_API,
  );

  const { mutate: getPlaceDetails, isPending } = useMutation({
    mutationFn: async ({ placeId }: { placeId?: string }) => {
      const response = await fetch(
        `https://places.googleapis.com/v1/places/${placeId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': googleMapsApiKey,
            'X-Goog-FieldMask': 'id,displayName,addressComponents,location',
          },
        },
      );

      const placeDetails = await response.json().catch(() => {});

      return placeDetails as google.maps.places.Place;
    },
    onSuccess,
  });

  return {
    getPlaceDetails,
    isPending,
  };
};

export { usePlaceDetails };
